import React from "react";
import MaterialTable from "material-table";
import { translator } from "../../utils/i18n";
import { useSelector } from "react-redux";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Tooltip from "@material-ui/core/Tooltip";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@material-ui/core/Button";

function MyFiles() {
  const files = useSelector(state =>
    state.patientArea.filesDownload ? state.patientArea.filesDownload : []
  );

  const state = {
    columns: [
      { title: `contenu`, field: "content", filtering: false },
      { title: `Date`, field: "date", filtering: false },
      { title: `Nom du fichier`, field: "fileName", filtering: false },
      { title: `Lien de téléchargement`, field: "fileLink" }
    ]
  };

  const buildHtml = () => {
    let newData = [];
    if (files) {
      newData = files.map(item => {
        const html = (
          <div className="wrap-item history">
            <div className="infos">
              <div className="name">
                <strong>{item.fileName}</strong>
              </div>
              <ul className="un-styled infos-user">
                <li>
                  <DateRangeIcon />
                  {item.date}
                </li>
              </ul>
            </div>
            <div className="settings p-0">
              <Tooltip title={translator()._("W_TELECHARGER")}>
                <Button
                  className="no-bg"
                  href={item.fileLink}
                  target="_blank"
                  rel="noopener"
                >
                  <GetAppIcon />
                </Button>
              </Tooltip>
            </div>
          </div>
        );
        return {
          content: html,
          id: item.id,
          fileLink: item.fileLink,
          fileName: item.fileName,
          date: item.date
        };
      });
    }
    return newData;
  };

  return (
    <div className="wrap-custom-table show-all-td">
      <h1 className="title-page">{translator()._("CP_MENU_DOCUMENTS")}</h1>
      <div className="wrap-inner-table filter-disabled">
        <MaterialTable
          title=""
          columns={state.columns}
          data={buildHtml()}
          showFirstLastPageButtons={false}
          options={{
            actionsColumnIndex: -1,
            maxBodyHeight: 250,
            pageSize: 3
          }}
          localization={{
            pagination: {
              labelDisplayedRows: "{from}-{to} of {count}",
              previousTooltip: `${translator()._("W_PREVIOUS_PAGE")}`,
              nextTooltip: `${translator()._("W_NEXT_PAGE")}`,
              lastTooltip: `${translator()._("W_LAST_PAGE")}`,
              firstTooltip: `${translator()._("W_FIRST_PAGE")}`
            },
            toolbar: {
              nRowsSelected: "{0} row(s) selected",
              searchPlaceholder: `${translator()._("CP_SEARCH")}`
            },
            header: {
              actions: "Actions"
            },
            body: {
              deleteTooltip: `${translator()._("W_SUPPRIMER")}`,
              emptyDataSourceMessage: `${translator()._(
                "CP_WELCOME_NO_DOCUMENT"
              )}`,
              filterRow: {
                filterTooltip: "Filter"
              },
              editRow: {
                deleteText: `${translator()._(
                  "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_RENDEZ_VOUS"
                )}`,
                cancelTooltip: `${translator()._("W_ANNULER")}`,
                saveTooltip: `${translator()._("W_STEP_BOUTON_CONTINUER")}`
              }
            }
          }}
        />
        <div className="profile-info">{translator()._("W_INFO_DOCUMENTS")}</div>
      </div>
    </div>
  );
}

export default MyFiles;
